export class PeopleRow {
    initalize(row) {
        this.rawRow = row
        this.consultantID = row[0]
        this.name = row[1]
        this.source = row[2]
        this.companyPrimaryName = row[3]
        this.companyStripedName = row[4]
        this.title = row[5]
        this.lastConfirmedDate = row[6]

        if (row.length == 8) {
            this.skills = row[7].split("; ")
        } else if (row.length == 9) {
            this.resume = row[8]
        }
    }
}